import { Component, OnInit } from '@angular/core';
import { ServerTokenService } from '../../services/server-token.service';

@Component({
  selector: 'ngx-referal-log',
  templateUrl: './referal-log.component.html',
  styleUrls: ['./referal-log.component.scss']
})
export class ReferalLogComponent implements OnInit {

  referalId: string;
  logs: any[];
  constructor(private server: ServerTokenService) { }

  ngOnInit(): void {

  }

  search() {
    if(! this.referalId ) {
      return;
    }
    this.server.postWithToken('snfs/admin/getCaseHistory', {referalId: this.referalId }).subscribe(data => {
      this.logs = data as any;
    });
  }

}
